import React, { FC, useEffect, useState } from "react";
import classNames from "classnames";
/* Direct path — avoid `@/ui` barrel (circular with `@/components` → tabs). */
import { Tabs as DsTabs } from "../../../ui/components/Tabs";

interface INavProps {
    content: JSX.Element;
    date?: string;
    title: string;
}

interface ITabProps {
    navs: INavProps[];
    className?: string;
    active?: string;
    onTabChange?: (tabId: string) => void;
    /** Visual only — defaults to horizontal (schedule / detail tabs). */
    orientation?: "horizontal" | "vertical";
}

/**
 * Legacy Tabs adapter — same `navs` / `active` / `onTabChange` contract.
 * Renders Treez DS `Tabs` under the hood (visual only; no business logic).
 */
const Tabs: FC<ITabProps> = ({
    navs,
    className,
    active,
    onTabChange,
    orientation = "horizontal",
}) => {
    const [activeTab, setActiveTab] = useState("0");

    useEffect(() => {
        if (active !== undefined) {
            setActiveTab(active);
            onTabChange?.(active);
        }
    }, [active]);

    const handleValueChange = (tab: string) => {
        if (activeTab !== tab) {
            onTabChange?.(tab);
            setActiveTab(tab);
        }
    };

    return (
        <DsTabs
            className={classNames("customer__details_tabs", className)}
            onValueChange={handleValueChange}
            orientation={orientation}
            value={activeTab}
        >
            <DsTabs.List aria-label="Tabs">
                {navs.map((nav, index) => (
                    <DsTabs.Trigger key={`${index}`} value={`${index}`}>
                        {nav.title}
                    </DsTabs.Trigger>
                ))}
            </DsTabs.List>
            {navs.map((nav, index) => (
                <DsTabs.Content key={`${index}`} value={`${index}`}>
                    {nav.content}
                </DsTabs.Content>
            ))}
        </DsTabs>
    );
};

export default Tabs;
